<template>
  <div class="mr-2" style="width:232px;">
          <el-date-picker
            v-model="defaultValue"
            type="daterange"
            :name="name"
            start-placeholder="siden"
            end-placeholder="før"
            value-format="yyyy-MM-dd">
          </el-date-picker>
      </div>
</template>

<script>
const Today = window.moment().format('YYYY-MM-DD');

export default {
  props: ['desde', 'hasta', 'name'],
  data() {
    return {
      defaultValue: this.desde ? [this.desde, this.hasta] : null
    };
  },
  mounted() {}
};
</script>


<style media="screen">
.el-input__inner {
  border: 1px solid #ced4da;
  border-radius: 0;
}
</style>
